import TelemedicineContext from '../context/telemedicine';

import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

export const FINISHED_STATUS = 'done';

// Once the call is over the patient must not get back into it: the room is marked done so the
// call routes refuse it, and the finished screen replaces the current entry so "back" can't
// land on the video room (which would reconnect with the still-valid token and LiveKit would
// auto-create a fresh, empty room).
const useFinishCall = () => {
	const navigate = useNavigate();
	const { updateTelemedicine } = useContext(TelemedicineContext);

	return useCallback(() => {
		updateTelemedicine({ status: FINISHED_STATUS });

		navigate('/telemedicine-finished', { replace: true });
	}, [navigate, updateTelemedicine]);
};

export default useFinishCall;
